import { Fragment } from "react";

import * as sx from "./key-value-grid.sx";
import { KeyValuePair } from "./key-value-pair";
import type { KeyValueContainerProps } from "./types";

export function KeyValueGrid({
  "data-testid": dataTestId,
  items,
  className,
  labelTransform = "uppercase",
}: KeyValueContainerProps) {
  return (
    <sx.Grid data-testid={dataTestId} className={className}>
      {items.map((item, index) => (
        <KeyValuePair
          key={index}
          // we want the label/value to be separate elements for grid layout
          component={Fragment}
          {...item}
          labelTransform={labelTransform}
        />
      ))}
    </sx.Grid>
  );
}

KeyValueGrid.slots = KeyValuePair.slots;
